import clsx from "clsx";
import React from "react";

import { type CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./Fieldset.module.css";

const ref = "fieldset";

interface FieldsetProps extends Partial<CommonProps> {
  children: React.ReactNode;
  inline?: boolean;
  legend: React.ReactNode;
  legendBackground?: boolean;
  legendPosition?: "center" | "right" | "default";
  noBorder?: boolean;
  noLegend?: boolean;
  noPadding?: boolean;
  subLegend?: React.ReactNode;
  thinBorder?: boolean;
}

function useFieldset(props: FieldsetProps) {
  const { color, legendBackground = true, legendPosition } = props;
  const className = clsx(
    styles[ref],
    color && styles[color],
    !legendBackground && styles.plain,
    legendPosition && styles[legendPosition],
    !props.inline && styles.stacked,
    props.noBorder && styles["no-border"],
    props.noLegend && styles["no-legend"],
    props.noPadding && styles["no-padding"],
    props.thinBorder && styles["thin-border"],
    props.className,
  );
  const id = props.id || createId(ref);

  return {
    className,
    id,
  };
}

function Fieldset(props: FieldsetProps) {
  const { children, subLegend } = props;
  const { className, id } = useFieldset(props);

  return children ? (
    <fieldset className={className} id={id}>
      <legend>{props.legend}</legend>
      {subLegend && <header>{subLegend}</header>}

      {children}
    </fieldset>
  ) : null;
}

export default Fieldset;
export { Fieldset, type FieldsetProps };
